<template>
    <div class="dropdown">
        <!-- Trigger -->
        <div @click="toggleDropdown" v-click-outside="onBlur">
            <slot name="trigger" :isOpen="isDropped" />
        </div>

        <!-- Dropdown Content -->
        <transition name="slide-fade">
            <div v-show="isDropped" class="dropdown__content">
                <ul v-if="data">
                    <DropdownItem v-for="(item, index) in data.data"
                                  :key="index"
                                  :item="item"
                                  :tag="'li'" />
                </ul>
                <slot v-else name="body" />
            </div>
        </transition>
    </div>
</template>

<script>
    import DropdownItem from "./DropdownItem";
    import ClickOutside from "vue-click-outside";
    export default {
        name: "Dropdown",
        components: { DropdownItem },
        directives: { ClickOutside },
        props: {
            data: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                isDropped: false
            };
        },
        methods: {
            toggleDropdown() {
                this.isDropped = !this.isDropped;
            },
            onBlur(event) {
                if(event && event.path){
                    let isTargetContainingDropdownMenu = event.path.find(x => x.className === 'dropdown--cart' || x.className === 'dropdown__content')
                    if(!isTargetContainingDropdownMenu){
                        this.isDropped = false;
                    }   
                } else {
                    this.isDropped = false;
                }
               
            }
        }
    };
</script>

<style scoped lang="scss">

    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
        transform-origin: top;
        transition: transform .2s, opacity .2s, visibility 0s .2s;
    }

    .slide-fade-leave-active {
        transform-origin: top;
        transform: rotateX(60deg);
        transition: transform .2s, opacity .2s, visibility 0s .2s;
    }

    .slide-fade-enter-from,
    .slide-fade-leave-to {
        opacity: 0;
        visibility: hidden;
    }

    .dropdown {
        position: relative;
    }

    .dropdown__content {
        position: absolute;
        right: 0;
        top: calc(100% + 4px);
        padding: 0;
        background-color: #ffffff;
        border-radius: 4px;
        white-space: nowrap;
        box-shadow: 0 0 12px 0 #3c4b6424, 0 2px 1px -1px #3c4b641f, 0 1px 3px 0 #3c4b6433;
        overflow: hidden;
        z-index: 8;
    }

        .dropdown__content ul {
            margin: 0;
            padding: 0;
            list-style: none;
        }

    .dropdown-action {
        display: block;
        width: 100%;
        padding: 0.6em 1em;
        border-top: solid 1px #0000000f;
        color: inherit;
        text-align: center;
        text-decoration: none;
        background-color: #0000000f;
    }

        .dropdown-action:hover {
            background-color: #00000021;
            text-decoration: none;
            color: inherit;
        }
</style>
